/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Print_Admin_Last_Seen_AtInputs */

const vi_print_admin_last_seen_at = /** @type {(inputs: Print_Admin_Last_Seen_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ping cuối: ${i?.time}`)
};

/**

* @param {Print_Admin_Last_Seen_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_last_seen_at = /** @type {((inputs: Print_Admin_Last_Seen_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Last_Seen_AtInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_last_seen_at(inputs)
});